import React, { createContext, useState, useEffect } from "react";

export const HueContext = createContext();

export function HueProvider({ children }) {
  const [hue, setHue] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setHue(prev => (prev + 2) % 360);
    }, 40);

    return () => clearInterval(interval);
  }, []);

  return (
    <HueContext.Provider value={hue}>
      {children}
    </HueContext.Provider>
  );
}
